<template>
  <div class="login-container">
    <div class="login-box">
      <h2>管理员登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input 
            type="text" 
            id="username" 
            v-model="loginForm.username" 
            placeholder="请输入用户名"
            required
          >
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <div class="password-input-wrapper">
            <input
              :type="showPassword ? 'text' : 'password'"
              id="password"
              v-model="loginForm.password"
              placeholder="请输入密码"
              required
            >
            <button type="button" class="toggle-password-btn" @click="showPassword = !showPassword">
              <span class="iconify" :data-icon="showPassword ? 'hugeicons:view-off' : 'hugeicons:view'"></span>
            </button>
          </div>
        </div>
        <button type="submit" class="login-btn" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>
      </form>
      <div v-if="message" class="message" :class="messageType">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import JSEncrypt from 'jsencrypt';

import config from '../config';

const API_BASE_URL = config.API_BASE_URL;

export default {
  name: 'ManageLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      publicKey: '',
      loading: false,
      message: '',
      messageType: '',
      showPassword: false
    };
  },

  methods: {
    async getPublicKey() {
      try {
        const response = await fetch(`${API_BASE_URL}/api/open/auth/public-key`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        if (data.code === '200') {
          this.publicKey = data.data.publicKey;
        } else {
          this.showMessage('获取公钥失败', 'error');
        }
      } catch (error) {
        this.showMessage('网络错误，无法获取公钥', 'error');
      }
    },
    encryptPassword(password) {
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.publicKey);
      return encrypt.encrypt(password);
    },
    async handleLogin() {
      this.loading = true;
      this.message = '';
      
      try {
        // 在登录前获取公钥
        await this.getPublicKey();
        
        if (!this.publicKey) {
          return;
        }
        
        const encryptedUsername = this.encryptPassword(this.loginForm.username);
        const encryptedPassword = this.encryptPassword(this.loginForm.password);
        const loginData = {
          encryptedUsername: encryptedUsername,
          encryptedPassword: encryptedPassword
        };
        
        const response = await fetch(`${API_BASE_URL}/api/open/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(loginData)
        });
        
        const data = await response.json();
        if (data.code === '200') {
          // 存储token
          localStorage.setItem('token', data.data.token);
          this.showMessage('登录成功', 'success');
          // 跳转到订单管理页面
          this.$router.push('/manage/order/list');
        } else {
          this.showMessage(data.message || '登录失败', 'error');
        }
      } catch (error) {
        this.showMessage('网络错误，登录失败', 'error');
      } finally {
        this.loading = false;
      }
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type;
      setTimeout(() => {
        this.message = '';
      }, 3000);
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #666;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #fff;
}

.form-group input:focus {
  outline: none;
  border-color: #409eff;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  width: 100%;
  padding-right: 40px;
}

.toggle-password-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.toggle-password-btn:hover {
  color: #666;
}

.login-btn {
  width: 100%;
  padding: 10px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-btn:hover:not(:disabled) {
  background-color: #66b1ff;
}

.login-btn:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.message {
  margin-top: 15px;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
}

.message.success {
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}

.message.error {
  background-color: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fbc4c4;
}
</style>
